import { ActionPayloadGeneric, CHUuid } from "@app/root-store/actions";
import { createActionSet, createNoPropsAction } from "@app/root-store/actions/action-creators";
import { CommandType } from "@app/rule/model/commands";

const actionCategory = "Rule Command";

export type ActionPayload = CHUuid & ActionPayloadGeneric;
export type BulkActionResult = CHUuid & {
    commands: Record<string, CommandType>;
};

export const loadSet = createActionSet<ActionPayload, BulkActionResult>(actionCategory, "load");
export const clearCommandState = createNoPropsAction(actionCategory, "clear");
